import { useState, useEffect } from "react";
import {
  Image as StyledImage,
  TitleContentsOverflowWrapper,
  Wrapper,
  TitleContentsWrapper,
} from "./SmsTitleContent.styled";
import { ContentsTooltip } from "~/components/ContentsTooltip";

type SmsTitleContentProps = {
  item: {
    imageUrl: string;
    title: string;
    contents: string;
  };
};

const TooltipImage = ({ imageUrl }: { imageUrl: string }) => {
  const [dimensions, setDimensions] = useState<{
    width: undefined | string;
    height: undefined | string;
  }>({
    width: undefined,
    height: undefined,
  });

  useEffect(() => {
    const img = new Image();
    img.src = imageUrl;
    img.onload = () => {
      const { width, height } = img;
      if (width > height) {
        setDimensions({ width: "180px", height: "auto" });
      } else {
        setDimensions({ width: "auto", height: "180px" });
      }
    };
  }, [imageUrl]);

  return (
    <Wrapper className="tooltip-image">
      <StyledImage
        alt="sms-image"
        src={imageUrl}
        width={dimensions.width}
        height={dimensions.height}
      />
    </Wrapper>
  );
};

export default TooltipImage;

export const SmsTitleContent = ({ item }: SmsTitleContentProps) => {
  return (
    <ContentsTooltip
      title={
        <div>
          {item.imageUrl && <TooltipImage imageUrl={item.imageUrl} />}
          <TitleContentsWrapper>
            <div>{item.title}</div>
            <div>{item.contents}</div>
          </TitleContentsWrapper>
        </div>
      }
    >
      <Wrapper>
        <TitleContentsOverflowWrapper>
          <div>{item.title}</div>
          <div>{item.contents}</div>
        </TitleContentsOverflowWrapper>
        {item.imageUrl && (
          <div>
            <StyledImage alt="sms-image" src={item.imageUrl} />
          </div>
        )}
      </Wrapper>
    </ContentsTooltip>
  );
};
